import { render, staticRenderFns } from "./proprietarioFrotaReport.vue?vue&type=template&id=d5c0b428"
import script from "./proprietarioFrotaReport.vue?vue&type=script&lang=js"
export * from "./proprietarioFrotaReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports